import { render } from "./TopicTrendingSection.vue?vue&type=template&id=a95277e6&scoped=true"
import script from "./TopicTrendingSection.vue?vue&type=script&lang=js"
export * from "./TopicTrendingSection.vue?vue&type=script&lang=js"

import "./TopicTrendingSection.vue?vue&type=style&index=0&id=a95277e6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a95277e6"]])

export default __exports__